import mixpanel from 'mixpanel-browser';
import {
  iosCreatorUARegex,
  iosListenerUARegex,
  androidCreatorUARegex,
  androidListenerUARegex,
  desktopUARegex,
  versionNumberRegex
} from 'lib/useragents';

mixpanel.init(`${import.meta.env.VITE_MIXPANEL_TOKEN}`);

const env_check = import.meta.env.PROD;

interface MixpanelProperties {
  URL: string;
  Platform: string;
  'App Version': string;
}

const getPlatform = (): string => {
  const ua = navigator.userAgent;
  switch (true) {
    case iosCreatorUARegex.test(ua):
    case iosListenerUARegex.test(ua):
      return 'iOS';
    case androidCreatorUARegex.test(ua):
    case androidListenerUARegex.test(ua):
      return 'Android';
    case desktopUARegex.test(ua):
      return getOperatingSystem();
    default:
      return 'unknown';
  }
};

const getOperatingSystem = (): string => {
  const ua = navigator.userAgent;
  switch (true) {
    case /(Macintosh|osx)/i.test(ua):
      return 'Mac';
    case /[W|w]indows/i.test(ua):
      return 'Windows';
    default:
      return 'unknown';
  }
};

const getAppVersion = (): string => {
  const ua = navigator.userAgent;
  const versionNumber = ua.match(versionNumberRegex) || ['unknown'];
  return versionNumber[0];
};

const defaultProperties = {
  URL: window.location.pathname,
  Platform: getPlatform(),
  'App Version': getAppVersion()
};

const actions = {
  identify: (id: string) => {
    if (env_check) mixpanel.identify(id);
  },
  track: (name: string, properties?: MixpanelProperties) => {
    if (env_check)
      mixpanel.track(name, { ...defaultProperties, ...properties });
  }
};

export const Mixpanel = actions;
